import {
  getListPackageInstallerApi,
  inactivePackageInstallerApi,
  upsertPackageInstallerApi,
} from "helpers/backend_helper"
import { takeEvery, put, call } from "redux-saga/effects"
import {
  getListPackageInstallerFail,
  getListPackageInstallerSuccess,
  inactivePackageInstallerFail,
  inactivePackageInstallerSuccess,
  upsertPackageInstallerFail,
  upsertPackageInstallerSuccess,
} from "./actions"
import {
  GET_LIST_PACKAGE_INSTALLER,
  INACTIVE_PACKAGE_INSTALLER,
  UPSERT_PACKAGE_INSTALLER,
} from "./actionTypes"

function* onGetListPackageInstaller() {
  try {
    const result = yield call(getListPackageInstallerApi)
    yield put(getListPackageInstallerSuccess(result))
  } catch (error) {
    yield put(getListPackageInstallerFail(error))
  }
}

function* onInactivePackageInstaller({ payload: data }) {
  try {
    yield call(inactivePackageInstallerApi, data)
    yield put(inactivePackageInstallerSuccess(data))
  } catch (error) {
    yield put(inactivePackageInstallerFail(error))
  }
}

function* onUpsertPackageInstaller({ payload: data }) {
  try {
    const result = yield call(upsertPackageInstallerApi, data)
    yield put(upsertPackageInstallerSuccess({
      message: "عملیات با موفقیت انجام شد",
      updatedData: result, // Always use result since backend returns complete Entity
      isNewItem: !data.id
    }))
  } catch (error) {
    yield put(upsertPackageInstallerFail(error))
  }
}

export default function* packageInstallerSaga() {
  yield takeEvery(GET_LIST_PACKAGE_INSTALLER, onGetListPackageInstaller)
  yield takeEvery(INACTIVE_PACKAGE_INSTALLER, onInactivePackageInstaller)
  yield takeEvery(UPSERT_PACKAGE_INSTALLER, onUpsertPackageInstaller)
}
